import Layers from "slotworks/graphics/layers/layers";
import AbstractTextControl from "slotworks/smart-ui/controls/abstract/abstract-text-control";
import { Control } from "slotworks/smart-ui/controls/control";
import ControlOptions from "slotworks/smart-ui/options/control-options";
import HeadlessSmartUIGroup from "slotworks/smart-ui/smart-ui-group";

export default class AutoplayReadyMessageTextControl extends AbstractTextControl implements Control {

    public setup(name: string, layer: Layers, assetName: string, assetNames: string[], smartUIGroup: HeadlessSmartUIGroup) {
        super.setup(name, layer, assetName, assetNames, smartUIGroup);
    }

    public updateOptions(options: ControlOptions) {
        super.updateOptions(options);

        let showText = options.autoplays.currentValue > 0;

        if (options.lossLimit.values && !options.lossLimitAmountIsValid()) {
           showText = false;
        }

        this.text.setVisible(showText);
    }
}
